import { ID_REGISTER } from 'civil-status/components/shared/list-register';
import { CodeTypeAct } from 'civil-status/constants/code-type-act';
import { SectionVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import { ModelEventoDTO } from 'shell/models/act-category-list';

export const transformerMarriageAct = (values?: ModelEventoDTO): SectionVM | undefined => {
  if (!values) {
    return;
  }

  const attoMatrimonio = values.separazione?.attoMatrimonio;

  const typeAct = Boolean(attoMatrimonio?.idAnsc)
    ? CodeTypeAct.attoDigitale
    : CodeTypeAct.attoCartaceo;

  return {
    typeAct,
    actForm: {
      idAnsc: attoMatrimonio?.idAnsc,
      dateAct: attoMatrimonio?.dataformazione
        ? DateTime.fromISO(attoMatrimonio?.dataformazione)
        : null,
      italian: attoMatrimonio?.idComuneRegistrazione
        ? {
            municipality: {
              id: attoMatrimonio?.idComuneRegistrazione || '',
              code: attoMatrimonio?.idComuneRegistrazione
                ? Number.parseInt(attoMatrimonio?.idComuneRegistrazione, 10)
                : undefined,
              description: attoMatrimonio.nomeComuneRegistrazione || '',
              province: attoMatrimonio.siglaProvinciaRegistrazione || '',
              idProvince: attoMatrimonio.idProvinciaRegistrazione
                ? Number.parseInt(attoMatrimonio.idProvinciaRegistrazione, 10)
                : undefined,
            },
          }
        : undefined,
      typeEvent: attoMatrimonio?.tipologia || '',
      register: ID_REGISTER.MATRIMONIO || '',
      year: attoMatrimonio?.annoAtto || '',
      municipalNumber: attoMatrimonio?.numeroatto || '',
      portion: attoMatrimonio?.parte || '',
      serie: attoMatrimonio?.serie || '',
      volume: attoMatrimonio?.volume || '',
    },
  };
};
